import {
  type MutableRefObject,
  createContext,
  useContext,
  useMemo,
} from 'react';

import { useContainerQuery } from '@fly/shared-hooks';

type ContentLayoutContextValue = {
  isContainerBigger: boolean;
};

export const ContentLayoutContext =
  createContext<ContentLayoutContextValue | null>(null);

export function useContentLayoutContext() {
  const value = useContext(ContentLayoutContext);

  if (value == null) {
    throw new Error(
      'useContentLayoutContext must be used within a ContentLayout'
    );
  }

  return value;
}

export function ContentLayoutProvider({
  maxWidth,
  containerRef,
  children,
}: {
  maxWidth: number;
  containerRef: MutableRefObject<HTMLDivElement | null>;
  children: React.ReactNode;
}) {
  const isContainerBigger = useContainerQuery(containerRef, maxWidth);
  const contextValue = useMemo(
    () => ({ isContainerBigger }),
    [isContainerBigger]
  );

  return (
    <ContentLayoutContext.Provider value={contextValue}>
      {children}
    </ContentLayoutContext.Provider>
  );
}
